import { Box } from '@mui/material';
import HeaderSearch from './Search';
import HeaderNotifications from './Notifications';

function HeaderButtons() {
  return (
    <Box
      sx={{
        mr: { xs: 0, sm: 1 },
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        gap: 0,
        flexShrink: 0
      }}
    >
      <HeaderSearch />
      <HeaderNotifications />
    </Box>
  );
}

export default HeaderButtons;
